import common_en from './translations/en/common.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

void i18n
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },
    lng: 'en',
    resources: {
      en: {
        common: common_en,
      },
    },
  })
  .then((r) => {});

export default i18n;
